import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import './MediaViewerHeader.less';

const HeaderBreadcrumbs = React.lazy(
  () =>
    import(
      '@components/MediaViewerHeader/components/HeaderBreadcrumbs/HeaderBreadcrumbs'
    )
);
const HeaderApprovalBreadcrumbs = React.lazy(
  () =>
    import(
      '@components/MediaViewerHeader/components/HeaderBreadcrumbs/HeaderApprovalBreadcrumbs'
    )
);

const HeaderActions = React.lazy(
  () => import('@components/MediaViewerHeader/components/HeaderActions')
);
const HeaderReviewerActions = React.lazy(
  () =>
    import(
      '@components/MediaViewerHeader/components/HeaderReviewerActions/HeaderReviewerActions'
    )
);
const HeaderReviewerApprovalActions = React.lazy(
  () =>
    import(
      '@components/MediaViewerHeader/components/HeaderReviewerActions/HeaderReviewerApprovalActions'
    )
);

const HeaderAssetInfo = React.lazy(
  () => import('@components/MediaViewerHeader/components/HeaderAssetInfo')
);
const HeaderBatchInfo = React.lazy(
  () => import('@components/MediaViewerHeader/components/HeaderBatchInfo')
);
export type MediaViewerHeaderProps = {
  view?:
    | 'external-share-asset'
    | 'external-approval-assets-list'
    | 'external-approval-asset'
    | 'approval-asset'
    | 'approval-assets-list';
  approvalWorkflowId?: string;
  password?: string | null;
  isEmbeddedWebView?: boolean;
};

function MediaViewerHeader({
  approvalWorkflowId,
  view,
  password,
  isEmbeddedWebView
}: MediaViewerHeaderProps) {
  const params = useParams();
  const _approvalWorkflowId = approvalWorkflowId || params.approvalId;
  if (view === 'external-share-asset') {
    return (
      <Suspense>
        <div className="media_viewer_header">
          <HeaderAssetInfo />
          <HeaderReviewerActions
            showApproval={false}
            showDropdownDecisions={false}
          />
        </div>
      </Suspense>
    );
  }
  if (view === 'external-approval-assets-list') {
    return (
      <Suspense>
        <div className="media_viewer_header">
          <HeaderBatchInfo />
          <HeaderReviewerActions
            showApproval={false}
            dropdownDecisionsType="approval-assets-list"
            password={password}
            approvalWorkflowId={_approvalWorkflowId}
          />
        </div>
      </Suspense>
    );
  }
  if (view === 'external-approval-asset') {
    return (
      <Suspense>
        <div className="media_viewer_header">
          <HeaderAssetInfo
            password={password}
            approvalWorkflowId={_approvalWorkflowId}
          />
          <HeaderReviewerActions
            password={password}
            approvalWorkflowId={_approvalWorkflowId}
          />
        </div>
      </Suspense>
    );
  }
  if (view === 'approval-assets-list') {
    return (
      <Suspense>
        <div className="media_viewer_header">
          <HeaderApprovalBreadcrumbs approvalWorkflowId={_approvalWorkflowId} />
          <HeaderReviewerApprovalActions
            approvalWorkflowId={_approvalWorkflowId}
          />
        </div>
      </Suspense>
    );
  }
  if (view === 'approval-asset') {
    return (
      <Suspense>
        <div className="media_viewer_header">
          <HeaderApprovalBreadcrumbs approvalWorkflowId={_approvalWorkflowId} />
          <HeaderActions isShowShareBtn={false} isShowDeadline />
        </div>
      </Suspense>
    );
  }
  return (
    <Suspense>
      <div className="media_viewer_header">
        <HeaderBreadcrumbs isEmbeddedWebView={isEmbeddedWebView} />
        <HeaderActions isEmbeddedWebView={isEmbeddedWebView} />
      </div>
    </Suspense>
  );
}

export default MediaViewerHeader;
